export default "https://cdn-static.gokick.com/assets/b18addbf7a1bb69f1adff96c45455352533f108a/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";